import {
  ClipboardList, FileText, LayoutDashboard, Radar, ShieldCheck, UserCheck, type LucideIcon,
} from 'lucide-react'

export type NavItem = {
  label: string
  to: string
  icon: LucideIcon
  /** v2 管理端需要登录令牌；无 token 时隐藏 */
  requiresAuth?: boolean
}

export const navItems: NavItem[] = [
  { label: '态势总览', to: '/command', icon: Radar },
  { label: '告警流水', to: '/events', icon: ClipboardList },
  { label: '监测站点', to: '/stations', icon: LayoutDashboard },
  { label: '直报审核', to: '/incidents', icon: FileText },
  { label: '灾情报告', to: '/reports', icon: FileText },
  { label: '管理后台', to: '/admin/users', icon: ShieldCheck, requiresAuth: true },
]

export const adminNavItems: NavItem[] = [
  { label: '用户与权限', to: '/admin/users', icon: ShieldCheck },
  { label: '角色与权限码', to: '/admin/roles', icon: ShieldCheck },
  { label: '审计日志', to: '/admin/audit', icon: ClipboardList },
  { label: '志愿者中心', to: '/admin/volunteers', icon: UserCheck },
  { label: '任务调度', to: '/admin/tasks', icon: LayoutDashboard },
]
